"use client";

import React from "react";
import { useForm } from "@formspree/react";

//components
import MainButton from "../MainButton";

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const ContactForm = ({ title }) => {
  const [, handleSubmit] = useForm("mbljlggd");

  return (
    <div className={cn("wrapper")} data-navbar-theme="light">
      <div className={cn("container")}>
        <div className={cn("title")}>
          <h2>{title}</h2>
        </div>
        <div className={cn("form-container")}>
          <div className={cn("form")}>
            <form onSubmit={handleSubmit}>
              <div className={cn("inputs")}>
                <input type="text" name="nome" id="name" placeholder="nome*" required />
                <input type="email" name="email" id="email" placeholder="email*" required />
                <textarea name="message" id="" cols="30" rows="10" placeholder="messaggio" required></textarea>
              </div>
              <div className={cn("form-footer")}>
                <div className={cn("checkbox")}>
                  <input type="checkbox" id="myCheckbox" name="myCheckbox" value="isChecked" required />
                  <label forhtml="myCheckbox">Ho preso visione ed accetto i termini della <a href="/privacy-policy">Privacy Policy</a>.</label>
                </div>
                <MainButton variant="primary" text={'invia richiesta'} type="submit" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;